<template>
  <v-container fluid class="qmkey-explorer-view">
    <v-row>
      <!-- View Title -->
      <v-col class="d-flex mt-1 mb-0 pb-0 ml-2" md="auto">
        <ViewTitle title="Departments & Roles" />
      </v-col>
      <v-col class="d-flex mb-0 pb-0">
        <v-btn
          rounded
          small
          class="add-button"
          @click.stop="addDepartmentForm()"
        >
          Add Department
        </v-btn>
      </v-col>
      <v-col
      class="d-flex justify-end mb-0 pb-0 component"
      md="auto"
      >
        <SearchTextAdmin @input="setSearchText" 
        @output="setSearchText"/>
      </v-col>
    </v-row>
    <!-- Department datatable -->
    <v-data-table
      fixed
      small
      :items="departments"
      :headers="departmentFields"
      dense
      item-class="qmkey-item-row"
      show-expand
      :search="search"
    >
      <!-- Actions -->
      <template v-slot:[`item.actions`]="{ item }">
        <v-icon small class="mr-2" @click.stop="editDepartmentForm(item)">
          mdi-pencil
        </v-icon>
        <v-icon small class="mr-2" @click.stop="addRoleForm(item)">
          mdi-plus
        </v-icon>
        <v-icon
          small
          icon
          class="mr-2"
          @click.stop="deleteDepartmentForm(item)"
          :disabled="!isAdmin"
        >
          mdi-trash-can-outline
        </v-icon>
      </template>
      <!-- Expanded -->
      <template v-slot:expanded-item="{ headers, item }">
        <td
          :colspan="headers.length + 1"
          class="qmkey-explorer-table-expansion-td"
        >
          <!-- needed to use row length -->
          <v-container fluid>
            <!-- Roles of Department datatable -->
            <v-row class="qmkey-explorer-table-expansion-cont">
              <v-tabs
                v-model="tabs"
                icons-and-text
                align-with-title
                background-color="#cac8c9"
                height="32"
                class="qmkey-explorer-table-expansion-panel"
                active-class="qmkey-explorer-table-expansion-panel-active"
              >
                <v-tabs-slider style="display: none"> </v-tabs-slider>
                <v-tab class="qmkey-explorer-table-expansion-panel-header">
                  <div class="tab">Roles</div>
                </v-tab>
              </v-tabs>
              <v-tabs-items
                v-model="tabs"
                class="qmkey-explorer-table-expansion-panel-contents"
              >
                <!-- Roles -->
                <v-tab-item
                  class="qmkey-explorer-table-expansion-panel-content"
                >
                  <div class="qmkey-related-inline-table">
                    <!-- Roles datatable -->
                    <v-data-table
                      :items="rolesOfDepartment(item.id)"
                      :headers="roleFields"
                      dense
                      item-class="qmkey-item-row"
                      sortBy="parent_name"
                    >
                      <!-- Role Actions -->
                      <template v-slot:[`item.actions`]="{ item }">
                        <v-icon
                          small
                          icon
                          class="mr-2"
                          @click.stop="editRoleForm(item)"
                          :disabled="!isAdmin"
                        >
                          mdi-pencil
                        </v-icon>
                        <v-icon
                          small
                          icon
                          class="mr-2"
                          @click="addSubRoleForm(item)"
                          :disabled="!isAdmin"
                        >
                          mdi-plus
                        </v-icon>
                        <v-icon
                          small
                          icon
                          class="mr-2"
                          @click.stop="deleteRoleForm(item)"
                          :disabled="!isAdmin"
                        >
                          mdi-trash-can-outline
                        </v-icon>
                      </template>
                    </v-data-table>
                  </div>
                </v-tab-item>
              </v-tabs-items>
            </v-row>
          </v-container>
        </td>
      </template>
    </v-data-table>
    <!-- Modal dialog -->
    <modal-dialog-form
      :title="modal_title"
      :showModalDialog="showModalDialog"
      :fields_to_collect="fields_to_collect"
      :submit_button_text="submit_button_caption"
      validate
      @close-dialog="toggle_dialog"
      @submit="submit_action"
    >
    </modal-dialog-form>
    <!-- /Modal dialog -->
  </v-container>
</template>

<script>
import { mapState, mapActions, mapMutations, mapGetters } from 'vuex'
import ViewTitle from '@/components/ViewTitle'
import Departments from '@/api/Departments'
import Roles from '@/api/Roles'
import ModalDialogForm from '@/components/explorer/ModalDialog'
import SearchTextAdmin from '@/components/header/SearchTextAdmin'

export default {
  name: 'RoleView',
  components: { ViewTitle, ModalDialogForm, SearchTextAdmin },
  data: function () {
    return {
      loading: false,
      message: null,
      departments: [],
      currentDepartment: {},
      roles: [],
      currentRole: {},
      selectedRoles: {},
      currentRoles: [],
      departmentFields: [
        { value: 'name', text: 'Name', align: 'start', sortable: true },
        { value: 'description', text: 'Description', sortable: true },
        {
          text: '',
          sortable: false,
          value: 'actions',
        },
        {
          value: 'data-table-expand',
          text: '',
          sortable: false,
          filterable: false,
        },
      ],
      roleFields: [
        {
          text: 'Name',
          align: 'start',
          sortable: true,
          value: 'name',
        },
        {
          text: 'Parent',
          sortable: true,
          value: 'parent_name',
        },
        { value: 'description', text: 'Description', sortable: true },
        {
          text: '',
          sortable: false,
          value: 'actions',
        },
      ],
      showModalDialog: false,
      modal_title: '',
      fields_to_collect: [],
      submit_button_caption: 'Save', // Harcoded text
      departments_fields_to_collect: [
        [
          {
            id: 'name',
            label: 'Name',
            required: true,
            value: null,
            readonly: false,
            hidden: null,
            cols: 4,
            class: null,
            component: 'TextInput',
            placeholder: 'Enter Name',
          },
        ],
        [
          {
            id: 'description',
            label: 'Description',
            required: false,
            value: null,
            readonly: false,
            hidden: null,
            cols: 8,
            class: null,
            component: 'TextareaInput',
            placeholder: 'Enter Description',
          },
        ],
      ],
      submit_action: function () {},
      tabs: null,
      search:'',
    }
  },

  computed: {
    ...mapGetters(['isAdmin', 'sitePath']),

  },

  mounted: function () {
    /* this.SET_CURRENT_SITE(this.$session.get('site')) */ // TODO: Remove this line?
    this.getDepartments()
    this.getRoles()
  },

  methods: {
    getDepartments() {
      Departments.get(this.sitePath)
        .then((response) => {
          this.departments = response.results
          for (var dep in this.departments) {
            this.refreshRolesOfDepartment(dep.id)
          }
        })
        .catch((err) => {
          console.log(err)
        })
    },
    getRoles() {
      console.log('getRoles this.departments', this.departments)
      Roles.get(this.sitePath)
        .then((response) => {
          this.roles = response.results
        })
        .catch((err) => {
          console.log(err)
        })
    },
    refreshRolesOfDepartment(department_id) {
      this.selectedRoles[department_id] = this.roles.filter(
        (role) => role.department == department_id,
      )
    },
    rolesOfDepartment(department_id) {
      return this.roles.filter((role) => role.department == department_id)
    },
    // DEPARTMENTS FORM methods
    addDepartmentForm() {
      // this.currentDepartment = {}
      this.modal_title = `Add new department`
      this.fields_to_collect = this.departments_fields_to_collect
      this.showModalDialog = true
      this.submit_action = this.addDepartment
      this.submit_button_caption = 'Save'
    },
    editDepartmentForm(item) {
      this.currentDepartment = item
      this.modal_title = `Edit department #${item.id}`
      this.showModalDialog = true
      this.fields_to_collect = [
        [
          {
            id: 'name',
            label: 'Name',
            required: true,
            value: item.name,
            readonly: false,
            hidden: null,
            cols: 4,
            class: null,
            component: 'TextInput',
            placeholder: 'Enter Name',
          },
        ],
        [
          {
            id: 'description',
            label: 'Description',
            required: false,
            value: item.description,
            readonly: false,
            hidden: null,
            cols: 8,
            class: null,
            component: 'TextareaInput',
            placeholder: 'Enter Description',
          },
        ],
      ]
      this.submit_action = this.updateDepartment
      this.submit_button_caption = 'Save'
    },
    deleteDepartmentForm(item) {
      this.currentDepartment = item
      this.modal_title = `Delete department #${item.id}-${item.name} `
      this.showModalDialog = true
      this.fields_to_collect = []
      this.submit_action = this.deleteDepartment
      this.submit_button_caption = 'Delete'
    },
    // Department process fomrs methods
    updateDepartment(formdata) {
      this.message = ''
      formdata.append('site', this.currentDepartment.site)
      Departments.put(this.sitePath, this.currentDepartment.id, formdata)
        .then(() => {
          this.loading = false
          this.getDepartments()
          this.toggle_dialog()
        })
        .catch((err) => {
          this.render_form_errors(err)
        })
    },
    addDepartment(formdata) {
      this.message = ''
      Departments.post(this.sitePath, formdata)
        .then(() => {
          this.getDepartments()
          this.toggle_dialog()
        })
        .catch((err) => {
          this.render_form_errors(err)
        })
    },
    deleteDepartment() {
      Departments.delete(this.sitePath, this.currentDepartment.id)
        .then((response) => {
          this.getDepartments()
          this.toggle_dialog()
        })
        .catch((err) => {
          this.render_form_errors(err)
        })
    },

    // ROLES FORM methods
    addRoleForm(row) {
      this.currentRole = { department: row.id, parent: null }
      this.currentRoles = this.rolesOfDepartment(row.id).map((role) => [
        role.id,
        role.name,
      ])
      this.currentRoles.unshift([null, 'Reports to anyone'])

      this.modal_title = `Add new role for ${row.name}`
      this.fields_to_collect = [
        [
          {
            id: 'name',
            label: 'Name',
            required: true,
            value: '',
            readonly: false,
            hidden: null,
            cols: 4,
            class: null,
            component: 'TextInput',
            placeholder: 'Enter Name',
          },
        ],
        [
          {
            id: 'description',
            label: 'Description',
            required: false,
            value: '',
            readonly: false,
            hidden: null,
            cols: 8,
            class: null,
            component: 'TextareaInput',
            placeholder: 'Reports to Role',
          },
        ],
        [
          {
            id: 'parent',
            label: 'Parent',
            required: false,
            value: null,
            readonly: false,
            hidden: null,
            cols: 4,
            class: null,
            component: 'Select',
            placeholder: 'Enter Description',
            items: this.currentRoles,
          },
        ],
      ]
      this.submit_action = this.addRole
      this.submit_button_caption = 'Save'
      this.showModalDialog = true
    },
    addSubRoleForm(item) {
      this.currentRole = { department: item.department, parent: item.id }
      this.currentRoles = this.rolesOfDepartment(item.department).map((role) => [
        role.id,
        role.name,
      ])
      this.currentRoles.unshift([null, 'Reports to anyone'])

      this.modal_title = `Add sub role for ${item.name}`
      this.fields_to_collect = [
        [
          {
            id: 'name',
            label: 'Name',
            required: true,
            value: '',
            readonly: false,
            hidden: null,
            cols: 4,
            class: null,
            component: 'TextInput',
            placeholder: 'Enter Name',
          },
        ],
        [
          {
            id: 'description',
            label: 'Description',
            required: false,
            value: '',
            readonly: false,
            hidden: null,
            cols: 8,
            class: null,
            component: 'TextareaInput',
            placeholder: 'Reports to Role',
          },
        ],
        [
          {
            id: 'parent',
            label: 'Parent',
            required: false,
            value: item.id,
            readonly: false,
            hidden: null,
            cols: 4,
            class: null,
            component: 'Select',
            placeholder: 'Enter Description',
            items: this.currentRoles,
          },
        ],
      ]
      this.submit_action = this.addRole
      this.submit_button_caption = 'Save'
      this.showModalDialog = true
    },
    editRoleForm(item) {
      console.log(item)
      this.currentRole = item
      this.modal_title = `Edit role #${item.id}`
      this.currentRoles = this.rolesOfDepartment(item.department).map(
        (role) => [role.id, role.name],
      )
      this.currentRoles.unshift([null, 'Reports to anyone'])
      this.showModalDialog = true
      this.fields_to_collect = [
        [
          {
            id: 'name',
            label: 'Name',
            required: true,
            value: item.name,
            readonly: false,
            hidden: null,
            cols: 4,
            class: null,
            component: 'TextInput',
            placeholder: 'Enter Name',
          },
        ],
        [
          {
            id: 'description',
            label: 'Description',
            required: false,
            value: item.description,
            readonly: false,
            hidden: null,
            cols: 8,
            class: null,
            component: 'TextareaInput',
            placeholder: 'Reports to Role',
          },
        ],
        [
          {
            id: 'parent',
            label: 'Parent',
            required: false,
            value: item.parent,
            readonly: false,
            hidden: null,
            cols: 4,
            class: null,
            component: 'Select',
            placeholder: 'Enter Description',
            items: this.currentRoles,
          },
        ],
      ]
      this.submit_action = this.updateRole
      this.submit_button_caption = 'Save'
    },
    deleteRoleForm(item) {
      this.currentRole = item
      this.modal_title = `Delete Role #${item.id}-${item.name} `
      this.showModalDialog = true
      this.fields_to_collect = []
      this.submit_action = this.deleteRole
      this.submit_button_caption = 'Delete'
    },
    // ROLES process form methods
    addRole(formdata) {
      formdata.append('department', this.currentRole.department)
      //formdata.append("site", this.sitePath)
      formdata.append('path', this.sitePath)
      this.message = ''
      Roles.post(this.sitePath, formdata)
        .then(() => {
          this.getRoles()
          this.getDepartments()
          this.toggle_dialog()
        })
        .catch((err) => {
          this.render_form_errors(err)
        })
    },
    updateRole(formdata) {
      this.message = ''
      formdata.append('department', this.currentRole.department)
      formdata.append('site', this.currentRole.site)
      formdata.append('path', this.sitePath)
      Roles.put(this.sitePath, this.currentRole.id, formdata)
        .then(() => {
          this.getRoles()
          this.getDepartments()
          this.toggle_dialog()
        })
        .catch((err) => {
          this.render_form_errors(err)
        })
    },
    deleteRole() {
      Roles.delete(this.sitePath, this.currentRole.id)
        .then((response) => {
          this.getRoles()
          this.getDepartments()
          this.toggle_dialog()
        })
        .catch((err) => {
          this.render_form_errors(err)
        })
    },
    toggle_dialog() {
      this.showModalDialog = false
      this.modal_title = ``
      this.fields_to_collect = []
      ;(this.submit_action = function () {}), (this.submit_button_caption = '')
      // this.$root.$loader.hide('I completed some action! Yay!', { timeout: 5000, location: 'top' }, () => { console.log( 'Callback after snackbar hidden' ) })
    },
    ...mapMutations(['SET_CURRENT_SITE']),
    setSearchText(search_text) {
      this.search=search_text
    },
  },
}
</script>


<style lang="scss">
@import '@/sass/explorer.scss';
</style>
